module.exports = __webpack_public_path__ + "img/fail-flag.7b7fa0c6.svg";